var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"color":"#000000"}},[_vm._v(_vm._s(_vm.$t("loginLineLoading")))])
}
var staticRenderFns = []

export { render, staticRenderFns }